<template lang="pug">
  div
    b-table(
      hover
      striped
      class='table-responsive-sm'
      :items='items'
      :fields='fields'
      :sort-by.sync='sortBy'
      :sort-desc.sync='sortDesc'
      @sort-changed='sortingChanged'
    )
      template(slot="status" slot-scope='data')
        b-badge(:variant="getBadge(data.item)") {{ statusText(data.item) }}
      template(slot="relatedStructures" slot-scope='data')
        b-link(v-for='structure in data.item.relatedStructures' :key='structure.url' :href='structure.url')
          b-badge.mr-2(variant='primary') {{ structure.name }}
          br
      template(slot='actions' slot-scope='data')
        c-table-actions(
          :id='data.item.id'
          :options='data.item.actionOptions'
        )
    nav
      b-pagination-nav(
        :link-gen='linkGen'
        :number-of-pages='totalPages'
        v-model='currentPage'
        prev-text='Prev'
        next-text='Next'
      )
</template>

<script>
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import Messages from '@/utils/notificationsMsg'
  import RouteGen from '@/utils/apiRoutes'
  import { normalizer } from '@/utils/resourceNormalizer'

  import cTableActions from './TableActions.vue'
  const pluralize = require('pluralize')

  export default {
    name: 'IndexTable',
    components: { cTableActions },
    data () {
      return {
        entity: this.$route.meta.entity,
        entityParams: {},
        items: [],
        currentPage: null,
        totalPages: null,
        perPage: null,
        totalRows: null,
        nextPage: null,
        prevPage: null,
        sortBy: 'created_at',
        sortDesc: true
      }
    },
    props: {
      fields: {
        type: Object,
        default: {}
      },
      initialSortBy: {
        type: String,
        default: 'created_at'
      },
      initialSortDesc: {
        type: Boolean,
        default: true
      },
      initialEntity: {
        type: String,
        default: null
      },
      initialEntityParams: {
        type: Object,
        default: null
      }
    },
    mounted () {
      let currentPermissions = this.$route.meta.roles
      if (!Policeman.authorize(currentPermissions)) {
        this.showNotification(401)
        this.$route.push({ name: 'Home' })
      }
      if (this.initialEntity) { this.$set(this.$data, 'entity', this.initialEntity) }
      if (this.initialEntityParams) { this.$set(this.$data, 'entityParams', this.initialEntityParams) }
      this.$set(this.$data, 'sortBy', this.initialSortBy)
      this.$set(this.$data, 'sortDesc', this.initialSortDesc)
      this.getResources(1, this.initialSortBy, this.initialSortDesc, {})
    },
    watch: {
      currentPage (newPage, oldPage) {
        if (newPage != null && oldPage != null && newPage > 0 && oldPage > 0) {
          let sort = this.$data.sortBy
          let desc = this.$data.desc
          this.getResources(newPage, sort, desc)
        }
      }
    },
    methods: {
      getResources (page = 1, sort = 'created_at', desc = true, otherParams = {}) {
        if (sort === null) { sort = 'created_at' }
        let route = RouteGen.index(this.entity)
        let order = (desc) ? 'desc' : 'asc'
        let parameters = Object.assign({ page: page, 'q[s]': (sort + ' ' + order) }, this.entityParams, otherParams)
        server.get(route, { params: parameters })
          .then(res => {
            this.setPager(res.headers)
            let formattedResources = res.data[pluralize(this.entity)].map(resource => {
              return normalizer(this.entity, resource)
            })
            this.$set(this.$data, 'items', formattedResources)
          })
          .catch(err => {
            console.log(err)
          })
      },
      statusText (item) {
        if (item.status) {
          if (item.defective) { return 'defect' }
          return 'completed'
        }
        return 'in progress'
      },
      getBadge (item) {
        if (item.status) {
          if (item.defective) { return 'danger' }
          return 'success'
        }
        return 'warning'
      },
      getRowCount (items) {
        return items.length
      },
      showNotification (status) {
        return this.showMessage(Messages.byStatus(status))
      },
      linkGen (pageNum) {
        return { path: '?page=' + pageNum }
      },
      setPager (data) {
        this.$set(this.$data, 'nextPage', parseInt(data['x-next-page']))
        this.$set(this.$data, 'prevPage', parseInt(data['x-prev-page']))
        this.$set(this.$data, 'currentPage', parseInt(data['x-page']))
        this.$set(this.$data, 'perPage', parseInt(data['x-per-page']))
        this.$set(this.$data, 'totalRows', parseInt(data['x-total']))
        this.$set(this.$data, 'totalPages', parseInt(data['x-total-pages']))
      },
      sortingChanged (variation) {
        this.getResources(this.$data.currentPage, variation.sortBy, variation.sortDesc)
      },
      filteredResources (filterParams) {
        this.getResources(1, 'created_at', true, filterParams)
      }
    },
    notifications: {
      showMessage: {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Shared/IndexTable.vue